import * as React from 'react';

export function SvgWindows(props: any) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 18.875v-6.25h8.75v7.344L2 18.875zM12 20.125v-7.5h10v8.75l-10-1.25zM12 11.375v-7.5l10-1.25v8.75H12zM2 11.375v-6.25l8.75-1.094v7.344H2z"
        fill="currentColor"
      />
    </svg>
  );
}
